// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__145KK","emails":"CreateEditClinics_emails__V2Ion","emailTagLabel":"CreateEditClinics_emailTagLabel__1DLIe"};